import { Box, Typography, LinearProgress } from "@mui/material";

interface RatingBarProps {
  label: string;
  value: number;
  max?: number;
}

export default function RatingBar({ label, value, max = 5 }: RatingBarProps) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 0.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
          }}
        >
          {value.toFixed(1)}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={(value / max) * 100}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: (th) => (th.palette.mode === "dark" ? "grey.800" : "grey.200"),
          "& .MuiLinearProgress-bar": {
            borderRadius: 4,
            backgroundColor: "primary.main",
          },
        }}
      />
    </Box>
  );
}
